<ul>
  @for (nav of navigation; track nav) {
    <li>
      @switch (nav.target) {
        @case (PDP) {
          <a
            [routerLink]="['/products']"
            (click)="goTo(nav)"
            routerLinkActive="active"
            class="text-content"
            >{{ nav.label | titlecase }}
          </a>
        }
        @case (PLP) {
          <a
            [routerLink]="['/products']"
            (click)="goTo(nav)"
            routerLinkActive="active"
            class="text-content"
            >{{ nav.label | titlecase }}
          </a>
        }
        @case (PROMOS) {}
        @case (INTERNAL_PAGE) {
          <a [routerLink]="['/' + nav.path]" routerLinkActive="active"
            >{{ nav.label }}
          </a>
        }
        @case (EXTERNAL_PAGE) {
          <a target="_blank" [href]="nav.path">{{ nav.label }} </a>
        }
        @default {
          <a href="#"> </a>
        }
      }
    </li>
  }
</ul>
